import { api } from "../api/apiCore";
import { cache, invalidateByPrefix } from '../utils/apiCache';

const USERS_TTL = 25 * 60 * 1000;

export function getUserNotifications(data) {
	const url = `/user/notifications`;

	return api.get(url)
}

export function removeUserNotification(data) {
	const url = `/user/notification/${data.notification_id}`;

	return api.delete(url);
}

export function viewedUserNotifications(data) {
	const url = `/user/notifications/markasviewed`;
	return api.postForm(url)
}

export function getAssignedUsersOfCompany(data) {
	let url;
	switch (data.userRole) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partnerName}/company/${data.companyName}/assignedusers`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partnerName}/company/${data.companyName}/assignedusers`;
			break;
		default:
			break;
	}

	return api.get(url)
}

export function getUserInfo() {
	return api.get(`/users/me`)
}

export function createFleetUser(data) {
   	const url = `/users/${data.email}`;

   	const form = new FormData();
	form.append('last_name', data.last_name);
	form.append('first_name', data.first_name);
	form.append('roles', data.role);
	form.append('password', data.password);
	form.append('phone_number', '1234567890');
	data.company_name ? form.append('company_name', data.company_name) : '';
	data.partner_name ? form.append('partner_name', data.partner_name) : '';

	return api.putForm(url, form).then((res) => {
		invalidateByPrefix('users:');
		return res;
	});
}

export function createFleetUserWithGroup (data, userRole, callback) {
	let url;
	switch (userRole) {
		case 'fleet_manager':
		case 'storage_manager':
			url = `/users/${data.email}`;
			break;
		case 'system_admin':
			url = `/system_admin/users/${data.email}`;
			break;
		case 'customer_service':
			url = `/customer_service/users/${data.email}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/users/${data.email}`;
			break;
	}

	const form = new FormData();
	form.append('last_name', data.last_name);
	form.append('first_name', data.first_name);
	form.append('roles', data.role);
	form.append('password', data.password);
	form.append('phone_number', '12345678');
	data.company_name ? form.append('company_name', data.company_name) : '';
	data.partner_name ? form.append('partner_name', data.partner_name) : '';

	return api.putForm(url, form)
		.then((resUser, err) => {
			invalidateByPrefix('users:');
			if (data.group) {
				let groups = [];
				if (Array.isArray(data.group)) {
					data.group.forEach((item) => {
						groups.push(item.value);
					});
				}
				else {
					groups = data.group.split(',');
				}

				let i = 0;
				groups.forEach((item) => {
					let groupUrl;
					switch (userRole) {
						case 'fleet_manager':
						case 'storage_manager':
							groupUrl = `/groups/${item}/users/${data.email}`;
							break;
						case 'system_admin':
							// groupUrl = `/system_admin/companies/${data.company_name}/groups/${item}/users/${data.email}`;
							groupUrl = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${item}/users/${data.email}`;
							break;
						case 'customer_service':
							groupUrl = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${item}/users/${data.email}`;
							break;
						case 'partner':
						case 'custom_partner':
							groupUrl = `/partners/companies/${data.company_name}/groups/${item}/users/${data.email}`;
							break;
						default:
							break;
					}

					api.putForm(groupUrl).then((res, err)=> {
						i++;
						if (i == data.group.length) {
							if (typeof callback === 'function') {
								return callback(null, {result:'ok', user_id: resUser.data.response.user.id})
							}
						}
					})
					.catch((error) => {
						if (typeof callback === 'function') {
							return callback(error, null)
						}
					});
				});
			} else {
				if (typeof callback === 'function') {
					return callback(null, {result:'ok', user_id: resUser.data.response.user.id});
				}
			}
		})
		.catch((error)=>{
			if (typeof callback === 'function') {
				return callback(error, null);
			}
		});
}

export function updateFleetUser(data) {
	let url
	switch (data.user_role) {
	case 'fleet_manager':
	case 'fleet_maintainer':
	case 'storage_manager':
	case 'group_manager':
	case 'user':
		url = `/users/${data.user_email}`
		break;
	case 'system_admin':
		url = `/system_admin/users/${data.user_email}`
		break;
	case 'customer_service':
		url = `/customer_service/users/${data.user_email}`
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/users/${data.user_email}`
		break;
	default:
		break;
	}

	const form = new FormData();
	const user = data.data
	Object.keys(user).forEach((key) => {
		form.append(key, user[key])
	})

	return api.postForm(url, form).then((res) => {
		invalidateByPrefix('users:');
		return res;
	});
}

export function updateFleetUserSettings (data) {
	let url
	switch (data.user_role) {
		case 'fleet_manager':
		case 'storage_manager':
			url = `/users/${data.user_email}/settings`
			break;
		case 'system_admin':
			url = `/system_admin/users/${data.user_email}/settings`
			break;
		case 'customer_service':
			url = `/customer_service/users/${data.user_email}/settings`
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/users/${data.user_email}/settings`
			break;
	}

	const form = new FormData(),
	user = data.data
	for (const key in user){
		form.append(key, user[key])
	}

	return api.putForm(url, form).then((res) => {
		invalidateByPrefix('users:');
		return res;
	});
}

export function deleteFleetUser(email) {
	const url = `/users/${email}`

	return api.delete(url).then((res) => {
		invalidateByPrefix('users:');
		return res;
	});
}

export function getUsers(userRole, company) {
	let url;
	switch (userRole) {
	case 'system_admin':
		url = `/system_admin/partner/${company.partner}/companies/${company.name}/users`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${company.partner}/companies/${company.name}/users`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${company.name}/users`;
		break;
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'storage_manager':
	case 'custom_user':
		url = `/users`;
		break;
	case 'sales_demo':
		url = `/sales_demo/partner/${company.partner}/companies/${company.name}/users`;
		break;
	default:
		break;
	}

	if (company.roles) {
		url += `?roles=${company.roles}`
	}

	const cacheKey = `users:${userRole}:${company.partner || ''}:${company.name || ''}:${company.roles || ''}`;
	return cache(cacheKey, () => api.get(url), USERS_TTL);
}

export function getAllUsers(){
	return cache(`users:all`, () => api.get(`/users/list`), USERS_TTL);
}

export function changeUserPassword (data) {
	// const url = `/auth/users/${data.user_email}/change_password`;
	// ToDo: Cognito - disable
	const url = `/users/${data.user_email}/change`;
	const form = new FormData();
	form.append('new_password', data.new_password);
	form.append('new_password_confirm', data.new_password_confirm);

	return api.postForm(url, form);
}

export function activateUserAccount (email) {
	const url = `/customer_service/users/confirm`;
	const form = new FormData();
	form.append('emails', email);

	return api.postForm(url, form);
}

export function getDokuWikiEULA(env) {
	let url;

	switch (env) {
		case 'localhost':
		// // url = `http://localhost/dokuwiki/_export/html/user:product:roscolive:roscolive2.0:eula`;
		// url = 'http://localhost/dokuwiki/_export/html/user:product:roscolive2.0:eula';
		// break;
		case 'test.roscolive.com':
		case 'dev.roscolive.com':
		case 'staging.roscolive.com':
		// url = `https://devwiki.roscocloud.com/_export/html/user:product:roscolive:roscolive2.0:eula`;
		// url = 'https://devwiki.roscocloud.com/_export/html/user:product:roscolive2.0:eula';
		// break;
		case 'canada.roscolive.com':
		case 'roscocloud.com':
		case 'www.roscocloud.com':
		case 'fleet.roscolive.com':
			// url = `https://wiki.roscocloud.com/_export/html/user:product:roscolive:roscolive2.0:eula`;
			url = 'https://support.roscovision.com/roscolive-eula';
			break;
	}

	return api.get(url, {
		headers: {
			'Content-Type': 'text/html',
		},
	});
}

export function agreeDokuWikiEULA() {
	const url = `/user/eula/view`;

	return api.postForm(url);
}

export function viewedLastReleaseDescription(timeReviewed) {
	const url = `/user/release/view`;

	const form = new FormData()
	form.append('time_reviewed', timeReviewed)

	return api.postForm(url, form);
}

export function addAuditLog(data) {
	const url = `/users/auditlogs`
	const form = new FormData()
	form.append('action', data.action)
	form.append('action_data', JSON.stringify(data.action_data))

	return api.putForm(url, form)
}

export function getUserLogs(data) {
	let url = `/users/${data.user_id}/auditlog?start_date=${data.start_date}&end_date=${data.end_date}`
	if (data.filter_type) {
		url =  url + `&filter_type=${data.filter_type}`
	}

	return api.get(url)
}

export function getCompanyLogs(data) {
	let url
	switch (data.user_role) {
		case 'system_admin':
		case 'customer_service':
		case 'sales_demo':
			url = `/companies/${data.company_id}/auditlog?start_date=${data.start_date}&end_date=${data.end_date}`
			break
		default:
			break;
	}
	if (data.filter_type) {
		url =  url + `&filter_type=${data.filter_type}`
	}

	return api.get(url)
}

export function completeNotification() {
	let url = `'/user/notification/reformat/complete'`;

	return api.postForm(url);
}

export function getVersion() {
	const url = `/version.json`;

	return api.get(url);
}

export function getDevicesProblems(data) {
	const { company_id } = data;
	const url = `/companies/${company_id}/devices/problems`;

	return api.get(url);
}

export function getReleases() {
	const url = `/releases`;

	return api.get(url);
}

export function getSupportTutorials() {
	const url = `/tutorials`;

	return api.get(url);
}
